import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import {
  MarkAllPendingPaidPayload,
  MarkSinglePendingPaidPayload,
  PayoutHistoryParams,
  PayoutQueueParams,
  UpdateWithdrawalStatusPayload,
} from 'BoostXpressAdmin/Model/payoutXModel'

export const payoutBXService = {
  pendingPayouts: async (params: PayoutQueueParams) => {
    return AuthXInterceptor.get('station-attendants/pending-payouts', { params })
  },

  payouts: async (params: PayoutHistoryParams) => {
    return AuthXInterceptor.get('station-attendants/payouts', { params })
  },

  markAllPaid: async (payload: MarkAllPendingPaidPayload) => {
    return AuthXInterceptor.post('station-attendants/pending-payouts/mark-all-paid', payload)
  },

  markSinglePaid: async (userId: string, payload: MarkSinglePendingPaidPayload) => {
    return AuthXInterceptor.post(
      `station-attendants/pending-payouts/${encodeURIComponent(userId)}/mark-paid`,
      payload,
    )
  },

  showWithdrawal: async (withdrawalId: string) => {
    return AuthXInterceptor.get(
      `station-attendants/withdrawals/${encodeURIComponent(withdrawalId)}`,
    )
  },

  updateWithdrawalStatus: async (
    withdrawalId: string,
    payload: UpdateWithdrawalStatusPayload,
  ) => {
    return AuthXInterceptor.put(
      `station-attendants/withdrawals/${encodeURIComponent(withdrawalId)}/status`,
      payload,
    )
  },
}

